import { pipe } from 'ramda';
import { useCallback, useMemo } from 'react';
import { ReminderConfiguration } from 'api/timesheets/configuration/api-configuration';
import { Configuration } from 'api/timesheets/configuration/configuration';
import { filter, ifPresent, map } from 'core/maybe';
import { maybeValueOf } from 'core/state';
import { SetState, State, UseStateResult } from './state';

const isEqual = (a: ReminderConfiguration, b: ReminderConfiguration) =>
  a.after === b.after && a.before === b.before;

export const useReminders = (
  configuration: State<Configuration>,
  setConfiguration: SetState<Configuration>,
): UseStateResult<ReminderConfiguration> => {
  const reminder = useMemo(
    () =>
      pipe(
        () => configuration,
        State.map((x) => x.reminder),
      )(),
    [configuration],
  );
  const setReminder = useCallback(
    (next: ReminderConfiguration) => {
      pipe(
        () => configuration,
        maybeValueOf,
        filter((x) => !isEqual(x.reminder, next)),
        map((x) => ({ ...x, reminder: next })),
        ifPresent(setConfiguration),
      )();
    },
    [configuration, setConfiguration],
  );

  return [reminder, setReminder];
};
